import React from 'react';
import './Section.css';
import './About.css';
import aboutImage from '../assets/innodata-logo-circle.png';

const About = () => {
  return (
    <section id="about" className="section about-section">
      <div className="section-content about-container">
        <div className="about-image-container">
          <img src={aboutImage} alt="About Us" className="about-image about-image-dark" />
        </div>
        <div className="about-text-container">
          <h1>About Us</h1>
          <p className="about-lead">
            Innodata is about delivering impactful, efficient digital solutions that uplift various industry sectors             and power modern organisations. With a strong foundation in agile methodologies
            and user-centric approaches, we translate complex problems into elegant, functional, and
            intuitive software.
          </p>
          <p className="about-body">
            <strong>Designed for New Zealand's Health Sector</strong><br />
            We understand the unique landscape of healthcare in Aotearoa New Zealand. Our solutions
            are built in strong alignment with the operational needs of Te Whatu Ora – Health New Zealand,
            Primary Health Organisations (PHOs), and community-based providers. We are committed to
            developing digital platforms that support the principles of Hauora - holistic well-being -
            by ensuring our software is secure, high-standard, reliable, and compliant with national
            privacy and data sovereignty standards.
          </p>
          <br/>
          <p className="about-body">
            <strong>Experiences in various Commercial domains</strong><br />
            Innodata also brings deep expertise in commercial domains, particularly in fintech and payment gateway solutions. Our team has hands-on experience in designing and delivering robust, Java-powered payment gateway integrations for organisations operating at a global scale. From multi-currency transaction flows and international payment exchange to secure API integrations with global payment providers, we help businesses process payments reliably, securely, and at speed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
